import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/dist/geosearch.css';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Custom icon using DivIcon
const customMarkerIcon = new L.DivIcon({
  className: 'custom-marker',
  html: `<div style="
    background-color: #007bff;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid white;
    transform: translate(-10px, -10px);
  "></div>`,
});

const SearchControl: React.FC<{ setPosition: (pos: { lat: number; lng: number }) => void ,setCoords:(lat: number, lng: number)=>void}> = ({ setPosition,setCoords }) => {
  const map = useMap();

  useEffect(() => {
    const provider = new OpenStreetMapProvider();

    const searchControl = new (GeoSearchControl as any)({
      provider,
      style: 'bar',
      showMarker: false, 
      autoClose: true,
      keepResult: true,
    });

    map.addControl(searchControl);

    map.on('geosearch/showlocation', (result: any) => {
      if (result && result.location) {
        const { lat, lon } = result.location.raw;
        setPosition({ lat, lng:lon });
        setCoords(lat, lon )
        map.setView([lat, lon], 13); 
      }
    });

    return () => {
      map.removeControl(searchControl);
    };
  }, [map, setPosition]);

  return null;
};

interface Prop{
    setCoords:(lat: number, lng: number)=>void;
    lat?:number,
    lng?:number
}
const MapInput = ({setCoords,lat=0,lng=0}:Prop) => {
  const [position, setPosition] = useState<{ lat: number; lng: number }>({ lat: lat, lng: lng });
  const {t}=useTranslation()
  const LocationMarker = () => {
    const map = useMap();

    useMapEvents({
      click(e) {
        setPosition(e.latlng);
        setCoords(e.latlng.lat, e.latlng.lng)
      },
    });

    useEffect(() => {
      map.setView([position.lat, position.lng], map.getZoom());
      
    }, [position, map]);

    return <Marker position={position} icon={customMarkerIcon} />;
  };

  const handleLatChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newLat = parseFloat(e.target.value);
    if (!isNaN(newLat)) {
      setPosition((prev) => ({ ...prev, lat: newLat }));
      setCoords(newLat, position.lng)
    }
  };

  const handleLngChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newLng = parseFloat(e.target.value);
    if (!isNaN(newLng)) {
      setPosition((prev) => ({ ...prev, lng: newLng }));
      setCoords(position.lat, newLng )
    }
  };



  return (
    <div>
      <MapContainer
        center={[position.lat, position.lng]}
        zoom={13}
        style={{ height: '400px', width: '100%' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <SearchControl setPosition={setPosition} setCoords={setCoords} />
        <LocationMarker />
      </MapContainer>

      <div style={{ marginTop: '20px',display:'flex',gap:'10px' }}>
     
        <TextField
							fullWidth
							size="small"
							type={'number'}
							label={t('T_latitude')}
					
                            value={position.lat}
                            onChange={handleLatChange}
							InputLabelProps={{
 								shrink: true,
								children: t('T_latitude'),
								sx: {
									fontSize: '18px',
 									
								},
							}}
							
							
							sx={{
								borderRadius: 3,
								"& .MuiOutlinedInput-root": {
									bgcolor: 'common.white',
									"& fieldset": {
										borderColor: 'grey.500',
									},
									borderRadius: 3,
								},
							}}
						
						/>
                          <TextField
							fullWidth
							size="small"
							type={'number'}
							label={t('T_longitude')} 
					
                            value={position.lng}
                            onChange={handleLngChange}
							InputLabelProps={{
 								shrink: true,
								children: t('T_longitude'),
								sx: {
									fontSize: '18px',
 									
								},
							}}
							
							
							sx={{
								borderRadius: 3,
								"& .MuiOutlinedInput-root": {
									bgcolor: 'common.white',
									"& fieldset": {
										borderColor: 'grey.500',
									},
									borderRadius: 3,
								},
							}}
						
						/>
     
      </div>
    </div>
  );
};

export default MapInput;
